import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { EquipmentStatusSchema } from '@/features/equipment/-constants';
import { equipmentListFilterFields } from '@/features/equipment/equipmentListFilterFields';
export const EquipmentItemDetailSearchSchema = z.object({
  ...dataGridSearchFields,
  status: EquipmentStatusSchema.default('ALL'),
  freeText: z.string().optional(),
  placementPlaceIdIn: equipmentListFilterFields.placementPlaceIdIn,
  warehousingPlaceIdIn: equipmentListFilterFields.warehousingPlaceIdIn
});
export type EquipmentItemDetailSearch = z.infer<typeof EquipmentItemDetailSearchSchema>;